import React from "react";
import Home from "./Home";
import PlanFilter from "./PlanFilter";
import Testimonials from "./Testimonials";
import Feature from "./Feature";
import Footer from "../Footer";

const Index = () => {
  return (
    <div>
      <Home />
      <PlanFilter />
      <Feature />
    </div>
  );
};

export default Index;
